import { combineReducers } from 'redux';
import { headerReducer } from './header/header.reducer';
import { deviceReducer } from './device/device.reducer';
import { reducer as toastr } from 'react-redux-toastr';
import { errorReducer } from './error/error.reducer';

const rootReducer = combineReducers({
  headerReducer,
  deviceReducer,
  toastr,
  errorReducer
});

export default rootReducer;